import { setUser } from '@sentry/react'
import { errorCodes, getAPIErrorMessage, getUserFriendlyErrorMessage } from '../../utils/errormessages'
import {
  CHANGE_TABS,
  EDIT_ADMIN_PASSWORD,
  EDIT_ADMIN_PASSWORD_ERROR,
  EDIT_ADMIN_PASSWORD_SUCCESS,
  GET_ADMIN_PROFILE,
  GET_ADMIN_PROFILE_ERROR,
  GET_ADMIN_PROFILE_SUCCESS,
  RESET_ADMIN_PROFILE_IMG,
  SET_ADMIN_PROFILE,
  SET_ADMIN_PROFILE_ERROR,
  SET_ADMIN_PROFILE_SUCCESS,
  SET_CURRENT_PROFILE_IMG,
  SET_CURRENT_PROFILE_IMG_ERROR,
  SET_CURRENT_PROFILE_IMG_SUCCESS,
  SET_ERROR_MSG,
  SET_IS_EDIT_SUCCESS,
  SET_IS_PROFILE_INFO_EDIT_SUCCESS,
  SET_PASSWORD_ERROR_MESSAGE,
  SET_TABS,
} from './AccountSettingsConstants'

const initialState = {
  loading: false,
  error: '',
  passwordErrorMessage: '',
  adminProfile: {},
  isEditPasswordSuccess: true,
  isProfileInfoEditSuccess: true,
  isEditSuccess: false,
  tabs: [
    { name: 'Account', isActive: true },
    { name: 'Security', isActive: false },
  ],
}
export default function accountSettingsReducer(state = initialState, action = {}) {
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  switch (action.type) {
    case SET_TABS:
      return {
        ...state,
        tabs: [
          { name: 'Account', isActive: true },
          { name: 'Security', isActive: false },
        ],
      }
    case CHANGE_TABS:
      return {
        ...state,
        tabs: state.tabs?.map((t) =>
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          t.name === action.payload ? { ...t, isActive: true } : { ...t, isActive: false },
        ),
      }
    case GET_ADMIN_PROFILE:
    case SET_ADMIN_PROFILE:
    case EDIT_ADMIN_PASSWORD:
    case SET_CURRENT_PROFILE_IMG:
      return {
        ...state,
        loading: true,
      }
    case GET_ADMIN_PROFILE_SUCCESS:
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setUser({ id: action.payload.AdminId })
      return {
        ...state,
        loading: false,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        adminProfile: action.payload,
      }
    case SET_ADMIN_PROFILE_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        adminProfile: { ...state.adminProfile, ...action.payload?.data },
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isProfileInfoEditSuccess: action.payload,
        loading: false,
      }
    case SET_CURRENT_PROFILE_IMG_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        adminProfile: { ...state.adminProfile, ImageUrl: action.payload.data.ImageUrl },
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isEditSuccess: action.payload,
        loading: false,
      }
    case SET_ERROR_MSG:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        error: action.payload,
      }
    case RESET_ADMIN_PROFILE_IMG:
      return {
        ...state,
        adminProfile: {},
      }
    case EDIT_ADMIN_PASSWORD_SUCCESS:
      return {
        ...state,
        isEditPasswordSuccess: true,
        isEditSuccess: true,
        loading: false,
      }
    case SET_IS_EDIT_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isEditSuccess: action.payload,
      }
    case SET_IS_PROFILE_INFO_EDIT_SUCCESS:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        isProfileInfoEditSuccess: action.payload,
      }
    case SET_PASSWORD_ERROR_MESSAGE:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        passwordErrorMessage: action.payload,
      }
    case EDIT_ADMIN_PASSWORD_ERROR:
      return {
        ...state,
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        passwordErrorMessage: getAPIErrorMessage(action.payload.ErrorCode),
        loading: false,
      }
    case GET_ADMIN_PROFILE_ERROR:
    case SET_ADMIN_PROFILE_ERROR:
    case SET_CURRENT_PROFILE_IMG_ERROR:
      let message = ''
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
        message =
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          action.payload.UserFriendlyErrorCode ?
            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
            getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
          : ''
      } else {
        // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
        switch (action.payload.ErrorCode) {
          case 'Network Error':
            message = getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION)
            break
          case 'TimeZoneNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.ITEM_DOES_NOT_EXIST, null, 'Timezone')
            break
          case 'ImageNotValid':
            message = getUserFriendlyErrorMessage(errorCodes.INVALID_FILE_FORMAT, null, '.jpg, .jpeg, .png')
            break
          case 'InternalServerError':
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
          default:
            message = getUserFriendlyErrorMessage(errorCodes.DEFAULT)
            break
        }
      }
      return {
        ...state,
        error: message,
        loading: false,
      }
    default: {
      return state
    }
  }
}
